export const getIdsTable = (data) => data.map((item) => item.portfolioId)
